<template>
  <div class="borrower-container">
    <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
    <div class="user-profile-container">
      <div class="info">
        <div class="name-block">
          <div class="user-name">
            {{ profile.name_ru.family_name_ru }}
            {{ profile.name_ru.given_name_ru }}
          </div>

          <div class="user-status" :class="`${profile.status}-profile`">
            {{ $t(`message.profile.status.${profile.status}`) }}
          </div>
        </div>
        <div class="user-role">
          <span>{{ $t("message.profile.role.title") }}</span>
          <span class="role">
            {{ $t(`message.profile.role.${this.profile.role}`) }}
          </span>
        </div>
        <div class="rate-block">
          <span>{{ $t("message.profile.rate") }}</span>
          <div class="rate" v-if="profile.rating > 0">{{ profile.rating }}</div>
          <div class="no-rate-block" v-if="profile.rating === 0">
            <img src="../../../public/custom/images/no-rate.svg" alt="Attention image">
            <span>{{ $t('message.profile.borrower.noRate') }}</span>
          </div>
        </div>
      </div>
      <button class="settings-btn" @click.stop="$router.push({ name: 'settings' })">
        <img src="../../../public/custom/images/settings.svg" alt="settings">
        <span>{{ $t('message.profile.settings') }}</span>
      </button>
    </div>
    <!-- <div class="user-info-container">
      <div class="user-status" :class="`${profile.status}-profile`">
        {{ $t(`message.profile.status.${profile.status}`) }}
      </div>
      <div class="user-info">
        <div class="user-name">
          {{ profile.name_ru.family_name_ru }}
          {{ profile.name_ru.given_name_ru }}
        </div>
      </div>
      <div class="rate-block">
        <span>{{ $t("message.profile.rate") }}</span>
        <div class="rate" v-if="profile.rating > 0">{{ profile.rating }}</div>
        <div class="no-rate-block" v-if="profile.rating === 0">
          <img src="../../../public/custom/images/attention.svg" alt="Attention image">
          <span>{{ $t('message.profile.borrower.noRate') }}</span>
        </div>
      </div>
      <div class="user-location">{{ userLocality }}</div>
      <div class="user-role">
        <span>{{ $t("message.profile.role.title") }}</span>
        &ensp;
        <span class="role">
          {{ $t(`message.profile.role.${this.profile.role}`) }}
        </span>
      </div>
    </div> -->
    <div class="notice-block" v-if="isVerifyingCardBlockVisible">
      {{ $t('message.profile.borrower.notice') }}
    </div>
    <div class="cards-block" v-if="isVerifyingCardBlockVisible">
      <verify-card v-for="card of verifyCardsList" :key="card.name" :settings="card" @action="cardAction"/>
    </div>
    <!-- <div class="no-scoring-agreement" v-if="profile.expiredCreditRegisterAgreement">
      {{ $t('message.profile.borrower.noScoringAgreement.start') }}
      <router-link class="no-card-link" to="scoring-agreement">{{ $t('message.profile.borrower.noScoringAgreement.link') }}</router-link>
      {{ $t('message.profile.borrower.noScoringAgreement.end') }}
    </div>
    <div class="no-card-container no-scoring-agreement" v-if="!profile.default_card_id">
      <router-link class="no-card-link" to="cards">{{ $t('message.profile.borrower.noCardLink') }}</router-link>
      {{ $t('message.profile.borrower.noCardText') }}
    </div> -->
    <div class="active-offers-container loans-container">
      <div class="active-offers-title">
        {{ $t('message.profile.borrower.activeOffers.title') }}
      </div>
      <div class="filters-block" @keyup.enter="setLoansFilter()">
        <div class="filter-block">
          <base-select
            :key="loansFilterSelectKey"
            :placeholder="$t('message.profile.lender.loans.filter.status')"
            :default-value="loansFilterStatus"
            :dictionary-path="'message.profile.lender.loans.filterStatus.list.'"
            :options-list="['overdue', 'current_debt', 'signing']"
            v-model="loansFilterStatus"
          />
        </div>
        <div class="filter-block">
          <input
            type="text"
            class="filter-input"
            v-model="loansFilter.full_name_lender"
            :placeholder="$t('message.profile.borrower.activeOffers.items.name')"
          >
        </div>
        <div class="datepicker-block">
          <base-datepicker
            v-model="loansFilter.receipt_date"
            :default-value="loansFilter.receipt_date"
            :format="'DD.MM.YYYY'"
            :range="true"
            :placeholder="$t('message.profile.lender.loans.filter.issued')"
          />
        </div>
        <div class="button-block">
          <base-button
            :text="$t('message.profile.lender.loans.filter.apply')"
            :min-height="'36px'"
            @click="setLoansFilter()"
          />
        </div>
        <div class="button-block">
          <base-button
            class="reset-filter-btn"
            :text="$t('message.profile.lender.loans.filter.reset')"
            :min-height="'36px'"
            @click="resetLoansFilter()"
          />
        </div>
      </div>
      <div class="loans-desktop-container">
        <table class="borrower-loans-table">
          <thead>
            <tr class="offers-item-header">
              <th class="agreement" scope="col">№ договора</th>
              <th class="name" scope="col">{{ $t('message.profile.borrower.activeOffers.items.name') }}</th>
              <th class="issued" scope="col">{{ $t('message.profile.borrower.activeOffers.items.issued') }}</th>
              <th class="amount" scope="col">{{ $t('message.profile.borrower.activeOffers.items.amount') }}</th>
              <th class="term" scope="col">{{ $t('message.profile.borrower.activeOffers.items.term') }}</th>
              <th class="percent" scope="col">{{ $t('message.profile.borrower.activeOffers.items.percent') }}</th>
              <th class="income" scope="col">{{ $t('message.profile.borrower.activeOffers.items.income') }}</th>
              <th class="issued-by" scope="col">{{ $t('message.profile.borrower.activeOffers.items.issuedBy') }}</th>
              <th class="peni" scope="col">{{ $t('message.profile.borrower.activeOffers.items.peni') }}</th>
              <th class="total-amount" scope="col">{{ $t('message.profile.borrower.activeOffers.items.totalAmount') }}</th>
              <th class="status" scope="col">{{ $t('message.profile.borrower.activeOffers.items.status') }}</th>
              <th class="pay" scope="col"></th>
            </tr>
          </thead>
          <tbody v-if="!isBorrowerLoansListEmpty">
            <borrower-loan-item
              v-for="item of loansList"
              :key="item.id"
              :item="item"
              @openTransactions="openLoanDetails"
              @openPayModal="openPayModal"
              @openEarlyRepaymentPay="openEarlyRepaymentPay"
              @openEarlyRepaymentNotify="openEarlyRepaymentNotify"
            />
          </tbody>
        </table>

        <div v-if="isBorrowerLoansListEmpty" class="empty-loans">{{ $t('message.profile.borrower.activeOffers.noLoans') }}</div>
      </div>
      <div class="loans-mobile-container">
        <mobile-borrower-loan-item
          v-for="item of loansList"
          :key="item.id"
          :item="item"
          @openTransactions="openLoanDetails"
          @openPayModal="openPayModal"
          @openEarlyRepaymentPay="openEarlyRepaymentPay"
          @openEarlyRepaymentNotify="openEarlyRepaymentNotify"
        />

        <div class="empty-loans" v-if="isBorrowerLoansListEmpty">{{ $t('message.profile.borrower.activeOffers.noLoans') }}</div>
      </div>
      <div class="table-footer">
        <div class="notice">* - без учёта комиссий</div>
        <div v-if="loansPagesCounter > 0" class="pagination-block">
          <pagination
            :prevButtonPlaceholder="'<'"
            :nextButtonPlaceholder="'>'"
            :current-page="loansParams.page"
            :pages-count="loansPagesCounter"
            :total-count="loansCount"
            :page-size="loansParams.size"
            @choice="setLoansPage"
          />
        </div>
      </div>
    </div>
    <base-modal
      v-if="isPayModalVisible"
      @close="closePayModal()"
    >
      <template #header>
        <div class="pay-modal">
          <div class="modal-header">
            <img @click.stop="closePayModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
          </div>
          <div class="modal-title">
            {{ $t('message.profile.borrower.activeOffers.payModal.title') }}
          </div>
          <div class="breakdown-list">
            <div class="breakdown-item">
              <span class="breakdown-label">{{ $t('message.profile.borrower.activeOffers.payModal.returnAmount') }}</span>
              <span class="breakdown-value">{{ paymentBreakdown.returnAmount }} {{ payModalCurrency }}</span>
            </div>
            <div class="breakdown-item">
              <span class="breakdown-label">{{ $t('message.profile.borrower.activeOffers.payModal.penalty') }}</span>
              <span class="breakdown-value">{{ paymentBreakdown.penalty }} {{ payModalCurrency }}</span>
            </div>
            <div class="breakdown-item breakdown-total">
              <span class="breakdown-label">{{ $t('message.profile.borrower.activeOffers.payModal.total') }}</span>
              <span class="breakdown-value">{{ paymentBreakdown.total }} {{ payModalCurrency }}</span>
            </div>
          </div>
          <div class="pay-input-block">
            <base-payment-input
              class="pay-input"
              :placeholder="$t('message.profile.borrower.activeOffers.payModal.placeholder')"
              :name="'loanPayConfirmation'"
              :validateRules="validateRules"
              v-model="payment.amount"
              :disabled="isPayBtnLoading"
            />
          </div>
          <div class="btn-block">
            <base-button
              :text="$t('message.profile.borrower.activeOffers.payModal.payBtn')"
              :disabled="isPayBtnDisabled"
              :is-loading="isPayBtnLoading"
              @click="startPayment()"
            />
          </div>
        </div>
      </template>
    </base-modal>
    <early-repayment-pay-modal
      v-if="isEarlyRepaymentPayVisible"
      :loan-public-id="earlyRepaymentLoanPublicId"
      @close="closeEarlyRepaymentPay()"
      @success="onEarlyRepaymentPaySuccess()"
    />
    <base-modal
      v-if="isAgreementModalVisible"
      @close="closeAgreementModal()"
    >
      <template #header>
        <div class="agreement-modal">
          <div class="modal-header">
            <img
              class="close-image"
              src="../../../public/custom/images/cross.svg"
              alt="Cross image"
              @click.stop="closeAgreementModal()"
            />
          </div>
          <div class="agreement-modal-title">
            {{ $t('message.profile.verifyCards.agreement.modal.title') }}
          </div>
          <div class="agreement-modal-description">
            {{ $t('message.profile.verifyCards.agreement.modal.description') }}
          </div>
          <div class="agreement-modal-buttons">
            <div class="agreement-modal-btn">
              <base-button
                class="agreement-modal-edit-btn"
                :text="$t('message.profile.verifyCards.agreement.modal.editBtn')"
                :min-height="'40px'"
                @click="goToEditWorkInfo()"
              />
            </div>
            <div class="agreement-modal-btn">
              <base-button
                :text="$t('message.profile.verifyCards.agreement.modal.giveConsentBtn')"
                :min-height="'40px'"
                @click="goToScoringAgreement()"
              />
            </div>
          </div>
        </div>
      </template>
    </base-modal>
    <actual-msi-info-modal
      v-if="isActualMsiInfoModalVisible"
      description-key="message.profile.verifyCards.annualActualInfo.modalDescription"
      @close="closeActualMsiInfoModal()"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import borrowerLoanItem from "./borrowerLoanItem.vue";
import BaseModal from "../../components/base/BaseModal.vue";
import BaseButton from "../../components/base/BaseButton.vue";
import BasePaymentInput from "../../components/base/BasePaymentInput.vue";
import MobileBorrowerLoanItem from "./mobileBorrowerLoanItem.vue";
import verifyCard from "./verifyCard.vue";
import Pagination from "../../components/common/Pagination.vue";
import EarlyRepaymentPayModal from "../../components/earlyRepayment/EarlyRepaymentPayModal.vue";
import BaseSelect from "../../components/base/BaseSelect.vue";
import BaseDatepicker from "../../components/base/BaseDatepicker.vue";
import ActualMsiInfoModal from "../Settings/actualMsiInfo/actualMsiInfoModal.vue";

const LOANS_REPAYMENT_POLLING_INTERVAL = 2000;

export default {
  name: "BorrowerProfile",
  inject: ['$httpService'],
  components: {
    borrowerLoanItem,
    BaseModal,
    BaseButton,
    BasePaymentInput,
    MobileBorrowerLoanItem,
    verifyCard,
    Pagination,
    EarlyRepaymentPayModal,
    BaseSelect,
    BaseDatepicker,
    ActualMsiInfoModal,
  },
  data() {
    return {
      isPayModalVisible: false,
      isAgreementModalVisible: false,
      isActualMsiInfoModalVisible: false,
      isEarlyRepaymentPayVisible: false,
      earlyRepaymentLoanPublicId: '',
      payment: {
        totalAmount: 0,
        amount: '',
        loan_public_id: '',
        initial_debt: 0,
        total_penalty: 0
      },
      isPayBtnLoading: false,
      loansParams: {
        page: 0,
        size: 10
      },
      loansFilter: {
        full_name_lender: undefined,
        receipt_date: undefined,
        status: undefined
      },
      loansFilterStatus: '',
      loansFilterSelectKey: 0,
      loansRepaymentPollingTimeoutId: null,
      isLoansRepaymentPollingDestroyed: false
    };
  },
  created() {
    this.restoreLoansState();
  },
  beforeDestroy() {
    this.destroyLoansRepaymentPolling();
  },
  methods: {
    restoreLoansState() {
      const { loansParams, loansFilter, loansFilterStatus } = this.$route.params || {};

      if (!loansParams && !loansFilter && !loansFilterStatus) {
        return;
      }

      this.loansParams = {
        ...this.loansParams,
        ...(loansParams || {})
      };
      this.loansFilter = {
        ...this.loansFilter,
        ...(loansFilter || {})
      };
      this.loansFilterStatus = loansFilterStatus || '';
    },
    getLoansRequestParams() {
      return {
        ...this.loansParams,
        filter: this.loansFilter
      };
    },
    async fetchLoansList(isSilent = false) {
      if (!isSilent) {
        this.$store.dispatch('loading', true);
      }

      try {
        await this.$store.dispatch('getLoansList', this.getLoansRequestParams());
      } finally {
        if (!isSilent) {
          this.$store.dispatch('loading', false);
        }
      }
    },
    hasInProgressRepaymentPayment(loans = this.loansList) {
      return (loans || []).some(item => item?.repaymentPayment?.in_progress === true);
    },
    scheduleLoansRepaymentPolling() {
      if (this.loansRepaymentPollingTimeoutId || this.isLoansRepaymentPollingDestroyed) {
        return;
      }

      this.loansRepaymentPollingTimeoutId = setTimeout(
        this.pollLoansRepaymentPayments,
        LOANS_REPAYMENT_POLLING_INTERVAL
      );
    },
    stopLoansRepaymentPolling() {
      if (this.loansRepaymentPollingTimeoutId) {
        clearTimeout(this.loansRepaymentPollingTimeoutId);
        this.loansRepaymentPollingTimeoutId = null;
      }
    },
    destroyLoansRepaymentPolling() {
      this.isLoansRepaymentPollingDestroyed = true;
      this.stopLoansRepaymentPolling();
    },
    async pollLoansRepaymentPayments() {
      this.loansRepaymentPollingTimeoutId = null;

      if (!this.hasInProgressRepaymentPayment()) {
        return;
      }

      try {
        await this.fetchLoansList(true);
      } finally {
        if (!this.isLoansRepaymentPollingDestroyed && this.hasInProgressRepaymentPayment()) {
          this.scheduleLoansRepaymentPolling();
        }
      }
    },
    async setLoansFilter() {
      this.loansParams.page = 0;
      await this.fetchLoansList();
    },
    async resetLoansFilter() {
      this.loansParams.page = 0;
      this.loansFilterStatus = '';
      this.loansFilterSelectKey += 1;
      this.loansFilter = {
        full_name_lender: undefined,
        receipt_date: undefined,
        status: undefined
      };
      await this.fetchLoansList();
    },
    async setLoansPage(page) {
      this.loansParams.page = page;
      await this.fetchLoansList();
    },
    getLoansBackRouteParams() {
      return {
        loansParams: {
          ...this.loansParams
        },
        loansFilter: {
          ...this.loansFilter
        },
        loansFilterStatus: this.loansFilterStatus
      };
    },
    openLoanDetails(id) {
      this.$router.push({
        name: 'loan',
        params: {
          id,
          backRouteName: 'profile',
          backRouteParams: this.getLoansBackRouteParams()
        }
      });
    },
    openEarlyRepaymentNotify(data) {
      this.$router.push({
        name: 'sign-early-repayment',
        params: {
          id: data.loan_public_id,
          backRouteName: 'profile',
          backRouteParams: this.getLoansBackRouteParams()
        }
      });
    },
    formatMoney(value) {
      return ((Number(value) || 0) / 100).toFixed(2);
    },
    cardAction(name) {
      if (name === 'card') {
        this.$router.push({ name: 'cards' });
      } else if (name === 'agreement') {
        this.handleAgreementAction();
      } else if (name === 'email') {
        this.$router.push({ name: 'change-contact-info' });
      } else if (name === 'annualActualInfo') {
        this.isActualMsiInfoModalVisible = true;
      }
    },
    closeActualMsiInfoModal() {
      this.isActualMsiInfoModalVisible = false;
    },
    handleAgreementAction() {
      const creditRegisterAgreement = this.profile?.CreditRegisterAgreement;

      if (Array.isArray(creditRegisterAgreement) && creditRegisterAgreement.length === 0) {
        this.goToScoringAgreement();
        return;
      }

      this.openAgreementModal();
    },
    openAgreementModal() {
      this.isAgreementModalVisible = true;
    },
    closeAgreementModal() {
      this.isAgreementModalVisible = false;
    },
    goToEditWorkInfo() {
      this.closeAgreementModal();
      this.$router.push({ name: 'edit-work-info-borrower' });
    },
    goToScoringAgreement() {
      this.closeAgreementModal();
      this.$router.push({ name: 'scoringAgreement' });
    },
    openPayModal(data) {
      this.payment = {...this.payment, ...data};
      this.isPayModalVisible = true;
    },
    openEarlyRepaymentPay(data) {
      this.earlyRepaymentLoanPublicId = data.loan_public_id;
      this.isEarlyRepaymentPayVisible = true;
    },
    closeEarlyRepaymentPay() {
      this.isEarlyRepaymentPayVisible = false;
      this.earlyRepaymentLoanPublicId = '';
    },
    async onEarlyRepaymentPaySuccess() {
      this.closeEarlyRepaymentPay();
      this.loansParams.page = 0;
      this.$emit('successPayment');
    },
    closePayModal() {
      if (!this.isPayBtnLoading) {
        this.isPayModalVisible = false;
      }
    },
    async startPayment() {
      this.isPayBtnLoading = true;
      const fixedAmount = (parseFloat(this.payment.amount).toFixed(2));
      const amount = (fixedAmount * 100).toFixed(0);
      const loan_public_id = this.payment.loan_public_id;

      try {
        const response = await this.$httpService.loan.loanPayment({ amount, loan_public_id });

        this.isPayBtnLoading = false;
        this.closePayModal();
        this.loansParams.page = 0;
        this.$emit('successPayment', response.data);
      } catch (error) {
        this.isPayBtnLoading = false;
        this.closePayModal();
      }
    }
  },
  computed: {
    ...mapGetters(['profile', 'loansList', 'loansCount']),
    userLocality() {
      return `${this.profile.address.locality}, ${this.profile.address.country}`;
    },
    verifyCardsList() {
      return [
        {
          name: 'email',
          disabled: false,
          visible: !this.profile?.emailVerified
        },
        // {
        //   name: 'verification',
        //   disabled: this.profile?.expiredCreditRegisterAgreement,
        //   visible: false
        // },
        {
          name: 'agreement',
          descKey: 'descBorrower',
          disabled: !this.profile?.emailVerified,
          visible: this.profile?.expiredCreditRegisterAgreement
        },
        {
          name: 'card',
          disabled: false,
          visible: !this.profile?.default_card_id
        },
        {
          name: 'annualActualInfo',
          disabled: false,
          visible: this.profile?.annual_actual_info?.required
        }
      ];
    },
    isVerifyingCardBlockVisible() {
      return this.verifyCardsList.some((item) => item.visible);
    },
    isBorrowerLoansListEmpty() {
      return this.loansList.length === 0;
    },
    loansPagesCounter() {
      return Math.ceil(this.loansCount / this.loansParams.size);
    },
    payModalCurrency() {
      return this.$t('message.profile.borrower.activeOffers.payModal.currency');
    },
    paymentBreakdown() {
      const returnAmount = Number(this.payment.initial_debt) || 0;
      const penalty = Number(this.payment.total_penalty) || 0;
      const total = Number(this.payment.totalAmount) || 0;

      return {
        returnAmount: this.formatMoney(returnAmount),
        penalty: this.formatMoney(penalty),
        total: this.formatMoney(total)
      };
    },
    validateRules() {
      return `loanPayConfirmation:${this.payment.totalAmount},10`;
    },
    isPayBtnDisabled() {
      const amountMinor = Number((parseFloat(this.payment.amount || 0) * 100).toFixed(0));
      return this.errors.items.length > 0 || amountMinor < 10 || this.isPayBtnLoading;
    }
  },
  watch: {
    loansFilterStatus(value) {
      if (value) {
        this.loansFilter.status = value;
      } else {
        this.loansFilter.status = undefined;
      }
    },
    'loansFilter.receipt_date'(value) {
      if (value && value[0] === null) {
        this.loansFilter.receipt_date = undefined;
      }
    },
    loansList: {
      handler(value) {
        if (this.hasInProgressRepaymentPayment(value)) {
          this.scheduleLoansRepaymentPolling();
        } else {
          this.stopLoansRepaymentPolling();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.borrower-container {
  @include base-page-container;

  flex-direction: column;
  color: #121212;
}

.user-info-container {
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
}

.user-profile-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  border-bottom: 1px solid #41bf7b;
}

.info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.name-block {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 20px;
}

.settings-btn {
  all: unset;
  width: 207px;
  height: 40px;
  box-sizing: border-box;
  padding: 6px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  color: #41bf7b;
  border: 2px solid #41bf7b;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  
  span {
    font-size: 14px;
    font-weight: 600;
    color: rgb(26, 141, 72);
  }

  &:hover {
    transform: scale(1.03);
  }
}

.user-info {
  margin-bottom: 20px;
  display: flex;
  align-items: flex-end;
}

.user-name {
  font-style: normal;
  font-size: 18px;
  line-height: 30px;
  font-weight: 600;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: rgb(18, 18, 18);
  text-transform: uppercase;
}

.user-location,
.user-role {
  gap: 4px;
  font-size: 14px;
  line-height: 22px;
}

.user-role {
  margin-bottom: 5px;
  display: flex;
  align-items: flex-end;
}

.role {
  font-weight: 600;
  color: #181a1b;
}

.rate-block {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  line-height: 22px;

  span {
    font-size: 14px;
  }
}

.no-rate-block {
  display: flex;
  align-items: center;

  img {
    margin-right: 7px;
    width: 24px;
    height: 24px;
  }

  span {
    font-weight: 600;
    font-size: 14px;
    color: rgb(173, 20, 26);
  }
}

.rate {
  font-weight: 600;
  font-size: 14px;
}

.no-card-container,
.no-scoring-agreement {
  margin-bottom: 60px;
  padding: 30px;
  box-sizing: border-box;
  width: fit-content;
  background: #F8F8F8;
  border: 1px solid #F49332;
  border-radius: 20px;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #101010;
}

.no-card-link {
  color: #41BF7B;
}

.notice-block {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  color: rgb(18, 18, 18);
  margin-top: 8px;
  margin-bottom: 30px;
}

.cards-block {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 360px));
  justify-content: flex-start;
  gap: 24px;
  margin-bottom: 48px;
}

.active-offers-container {
  @include active-offers-container;
  @include borrower-loans-table;

  min-width: auto;
  overflow-x: auto;
}

.active-offers-title {
  @include active-offers-title;
}

.filters-block {
  width: 100%;
  min-height: 36px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 16px;

  .filter-block {
    width: 190px;
    height: 36px;

    ::v-deep .input-wrapper {
      margin-bottom: 0;
      height: 100%;
    }

    ::v-deep .select-block {
      height: 36px;
    }

    ::v-deep .error-block {
      display: none;
    }
  }

  .button-block {
    width: 125px;
    height: 36px;
    margin-top: 0;

    ::v-deep .button {
      min-height: 36px;
      max-height: 36px;
      height: 36px;
      padding: 0 12px;
      border-radius: 6px;
    }
  }

  .reset-filter-btn {
    @include secondary-btn;
  }

  .datepicker-block {
    width: 230px;
    height: 36px;

    ::v-deep .mx-datepicker {
      width: 100%;
      height: 36px;
    }

    ::v-deep .mx-input-wrapper {
      height: 36px;
    }

    ::v-deep .mx-input {
      height: 36px;
    }
  }

  .filter-input {
    padding: 0 10px;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #CDCDCD;
    outline: none;

    &:active {
      border: 1px solid #DCDCDC;
    }
  }
}

.pay-modal {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px;
}

.modal-header {
  @include modal-close-block;
  width: 100%;
}

.agreement-modal {
  width: 520px;
  max-width: calc(95vw - 30px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.agreement-modal-title {
  margin-bottom: 12px;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #01273B;
}

.agreement-modal-description {
  margin-bottom: 28px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #01273B;
}

.agreement-modal-buttons {
  width: 100%;
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.agreement-modal-btn {
  flex: 1;
  height: 40px;
}

.agreement-modal-edit-btn ::v-deep {
  background-color: white;
  color: #41BF7B;
  border: 2px solid #41BF7B;

  &:hover:not(.disabled) {
    color: #FFFFFF;
  }
}

.agreement-modal-btn ::v-deep .button {
  min-height: 40px;
  max-height: 40px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 24px;
}

.close-image {
  cursor: pointer;
}

.modal-title {
  margin-bottom: 24px;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #101010;
}

.breakdown-list {
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.breakdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}

.breakdown-label {
  color: #878787;
}

.breakdown-value {
  font-weight: 600;
  color: #121212;
  white-space: nowrap;
}

.breakdown-total {
  padding-top: 16px;
  border-top: 1px solid #eceef0;

  .breakdown-label,
  .breakdown-value {
    font-weight: 600;
    font-size: 18px;
    color: #1a8d48;
  }
}

.pay-input-block {
  margin-bottom: 24px;
  width: 280px;
  max-width: 100%;
  height: 60px;
}

.pay-input ::v-deep {
  input,
  input::placeholder {
    text-align: center;
  }
}

.btn-block {
  margin-bottom: 20px;
  width: 280px;
  max-width: 100%;
  height: 40px;
}

.user-status {
  width: fit-content;
  padding: 4px 8px;
  box-sizing: border-box;
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
}

.new-profile {
  color: #1a6fb5;
  background: #e3f0ff;
}

.active-profile {
  color: #21A15C;
  background: #D6F9D3;
}

.inactive-profile {
  color: #6b6b6b;
  background: #eceef0;
}

.waiting-profile,
.on_approval-profile,
.confirmed-profile {
  color: #CB7723;
  background: #FFF1D5;
}

.blocked-profile {
  color: #c93434;
  background: #ffdbdb;
}

.table-footer {
  margin-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pagination-block {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
}

.more-block {
  margin-top: 15px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.notice {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #333333;
  }

.more-container {
  width: fit-content;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  cursor: pointer;

  img {
    margin-left: 5px;
  }
}

.route-name {
  @include route-name;
}

.empty-loans {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  box-sizing: border-box;
}

.loans-mobile-container {
  display: none;
  flex-direction: column;
}

@media screen and (max-width: 850px) {
  .cards-block {
    grid-template-columns: 1fr;
  }

  .loans-container .filters-block {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 12px;

    .filter-block,
    .datepicker-block,
    .button-block {
      width: 100%;
    }

    .button-block ::v-deep .button {
      width: 100%;
      max-width: 100%;
    }
  }

  .loans-desktop-container {
    display: none;
  }

  .loans-mobile-container {
    display: flex;
  }

  .user-profile-container {
    flex-direction: column;
  }

  .settings-btn {
    margin-bottom: 20px;
  }

  .agreement-modal-buttons {
    flex-direction: column;
  }
}
</style>
